export default __webpack_public_path__ + "static/media/large.c39ce68a.jpg";